import axios from 'axios';

const metaTag = () => document.querySelector('meta[name="csrf-token"]');

const csrfToken = () => {
  const m = metaTag();
  return (m && m.getAttribute('content')) || '';
};

const setCsrfToken = (token) => {
  const m = metaTag();
  if (m) m.setAttribute('content', token);
};

let refreshing = null;
const refreshCsrfToken = () => {
  if (!refreshing) {
    refreshing = axios
      .get('/csrf_token', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((res) => { setCsrfToken(res.data.token); return true; })
      .catch(() => false)
      .then((ok) => { refreshing = null; return ok; });
  }
  return refreshing;
};

export const attachCsrf = (instance) => {
  instance.interceptors.request.use((config) => {
    config.headers['X-CSRF-Token'] = csrfToken();
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  });

  instance.interceptors.response.use(
    (res) => res,
    (error) => {
      const res = error.response;
      const isCsrfError =
        res && res.status === 422 && res.data && res.data.error === 'invalid_csrf_token';

      if (!isCsrfError || !error.config || error.config.__csrfRetried) {
        return Promise.reject(error);
      }
      error.config.__csrfRetried = true;
      return refreshCsrfToken().then((ok) =>
        ok ? instance.request(error.config) : Promise.reject(error)
      );
    }
  );

  return instance;
};

export default function apiClient(options = {}) {
  return attachCsrf(axios.create({ withCredentials: true, ...options }));
}
